import datapoints from '../datapoints';
import getDatapointOptions from '../getDatapointOptions';
import { AddinCommand, InvokeAppAddinCommandStatusCode } from 'owa-addins-store';
import { ExtensionEventResult } from 'owa-addins-store';
import { getClientApp } from 'owa-session-store';
import { ItemSendEventReason } from '../enums/ItemSendEventReason';
import { PerformanceDatapoint } from 'owa-analytics';

// 15 minute timeout for ItemSend
const ITEMSEND_TIMEOUT_IN_MS = 900000;

export function createItemSendEventDatapoint() {
    const { name } = datapoints.ExtItemSendEvent.datapoint;
    const options = getDatapointOptions();
    options.timeout = ITEMSEND_TIMEOUT_IN_MS;
    return new PerformanceDatapoint(name);
}

export function endItemSendEventWithReason(
    datapoint: PerformanceDatapoint,
    reason: ItemSendEventReason
) {
    const { customData } = datapoints.ExtItemSendEvent.datapoint;
    datapoint.addCustomData(customData(reason));
    datapoint.end();
}

export function endItemSendEventDatpoint(
    datapoint: PerformanceDatapoint,
    result: ExtensionEventResult,
    addinCommand: AddinCommand
) {
    const { customData } = datapoints.ExtItemSendEvent.datapoint;
    datapoint.addCustomData(
        customData(
            getReason(result),
            addinCommand.extension.Id,
            addinCommand.extension.DisplayName,
            getClientApp()
        )
    );
    datapoint.end();
}

function getReason(result: ExtensionEventResult) {
    if (result.status === InvokeAppAddinCommandStatusCode.Success) {
        return result.allowEvent
            ? ItemSendEventReason.AllowEventTrue
            : ItemSendEventReason.AllowEventFalse;
    } else {
        switch (result.status) {
            case InvokeAppAddinCommandStatusCode.TimedOut:
                return ItemSendEventReason.FunctionTimedOut;
            case InvokeAppAddinCommandStatusCode.FunctionNotFound:
                return ItemSendEventReason.FunctionNotFound;
            default:
                return ItemSendEventReason.Unknown;
        }
    }
}
